import { ServiceBase } from './ServiceBase'

export class Activity extends ServiceBase {
 
}
